module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_comida_23.af3e654e.png";